import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const RefundPage = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };
  
  return (
    <div className="p-[4%] bg-bggreen min-h-screen">
      <div className="flex justify-center items-center relative mb-6">
        {/* Back Arrow Icon */}
        <button
          onClick={handleGoBack}
          className="absolute left-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-gray-700" />
        </button>

        {/* Title */}
        <p className="text-[20px] md:text-[24px] lg:text-[3vw] font-poppins font-[700]">
          <strong>Refund Policy</strong>
        </p>
      </div>
      
      {/* Refund Policy Content */}
      <div className="bg-bggreen rounded-lg  p-6 font-poppins">
        <p className="text-gray-700 mb-4">
          At Livmo, we are committed to providing exceptional healthcare services through our subscription plans. Please review our refund policy for our monthly and yearly healthcare service subscriptions:
        </p>
        
        <ul className="list-disc pl-6 space-y-3 text-gray-700">
          <li>Subscription cancellations must be requested at least 7 days before your next billing cycle to avoid automatic renewal charges.</li>
          <li>Monthly subscriptions are eligible for a partial refund if canceled within the first 14 days of the billing cycle.</li>
          <li>Yearly subscriptions come with a 30-day money-back guarantee from the date of purchase.</li>
          <li>To request a refund, please contact our support team with your subscription details and reason for cancellation.</li>
          <li>Refunds for yearly subscriptions will be prorated based on the unused portion of your subscription period.</li>
          <li>Once your refund request is received and inspected, we will send you an email notification within 5 business days.</li>
          <li>If approved, your refund will be processed, and a credit will automatically be applied to your original method of payment within 10 business days.</li>
          <li>Services already utilized (such as consultations, tests, or treatments) during the subscription period are non-refundable.</li>
          <li>Promotional or discounted subscriptions may have different refund eligibility terms as specified during purchase.</li>
          <li>In cases of technical issues that prevent access to our services, we will first attempt to resolve the issue before processing any refunds.</li>
          <li>If you experience unsatisfactory service quality, please report it to our quality assurance team for investigation before requesting a refund.</li>
          <li>We reserve the right to modify this refund policy at any time, with changes communicated to current subscribers via email.</li>
        </ul>
        
        <p className="text-gray-700 mt-6">
          If you have any questions about our refund policy or need assistance with your subscription, please contact our customer service team at info@livmo.in or call our support line at 97890 86627 for HELP.
        </p>
      </div>
    </div>
  );
};

export default RefundPage;